// CGN (23/10/2026): Resume la lectura de sondas (api/probes/get) en gasóleo (códigos 1 y 2) y SP95 (códigos 5 y 6), con los campos que
// usan los indicadores de las cisternas. El porcentaje se calcula sobre la suma de capacidades de cada producto
export function getProbeFuelSummary(tanks) {
	const summarize = (codes) => {
		const list = (tanks ?? []).filter(el => codes.includes(el.codigo_producto));
		const capacity = list.reduce((acc, el) => acc + (el.capacity ?? 0), 0);
		const available = list.reduce((acc, el) => acc + (el.available ?? 0), 0);
		return { available: available, percent: capacity > 0 ? (available * 100) / capacity : 0 };
	};

	const diesel = summarize(['1', '2']);
	const splomo = summarize(['5', '6']);
	return {
		diesel_available: diesel.available,
		diesel_percent: diesel.percent,
		splomo_available: splomo.available,
		splomo_percent: splomo.percent,
	};
}
